<script setup lang="ts">
import { twMerge } from "tailwind-merge";

import { useUser } from "@/composables/api/useUser";

import Button from "@/components/ui/Button.vue";

const { data: user } = useUser();
const model = defineModel<"missingPoints" | "missingProduct" | "other" | null>({ required: true });
</script>

<template>
  <div class="flex w-full flex-col gap-8">
    <h1
      :class="
        twMerge(
          'text-galbani text-2xl font-semibold',
          user?.current_mechanic === 'lactel' && 'text-lactel-blue',
        )
      "
    >
      {{ $t("dialog.claim.title") }}
    </h1>

    <div class="flex flex-col gap-12">
      <div class="flex flex-col gap-3">
        <div class="flex flex-col gap-2">
          <h2
            :class="
              twMerge(
                'text-galbani text-lg font-semibold',
                user?.current_mechanic === 'lactel' && 'text-lactel-blue',
              )
            "
          >
            {{ $t("dialog.claim.missingPoints.title") }}
          </h2>

          <p class="text-secondary font-medium">
            {{ $t("dialog.claim.missingPoints.description") }}
          </p>
        </div>

        <Button variant="secondary" @click="model = 'missingPoints'">
          {{ $t("dialog.claim.missingPoints.button") }}
        </Button>
      </div>

      <div class="flex flex-col gap-3">
        <div class="flex flex-col gap-2">
          <h2
            :class="
              twMerge(
                'text-galbani text-lg font-semibold',
                user?.current_mechanic === 'lactel' && 'text-lactel-blue',
              )
            "
          >
            {{ $t("dialog.claim.missingProduct.title") }}
          </h2>

          <p class="text-secondary font-medium">
            {{ $t("dialog.claim.missingProduct.description") }}
          </p>
        </div>

        <Button variant="secondary" @click="model = 'missingProduct'">
          {{ $t("dialog.claim.missingProduct.button") }}
        </Button>
      </div>

      <div class="flex flex-col gap-3">
        <div class="flex flex-col gap-2">
          <h2
            :class="
              twMerge(
                'text-galbani text-lg font-semibold',
                user?.current_mechanic === 'lactel' && 'text-lactel-blue',
              )
            "
          >
            {{ $t("dialog.claim.other.title") }}
          </h2>

          <p class="text-secondary font-medium">
            {{ $t("dialog.claim.other.description") }}
          </p>
        </div>

        <Button variant="primary" @click="model = 'other'">
          {{ $t("dialog.claim.other.button") }}
        </Button>
      </div>
    </div>
  </div>
</template>
